import { JsonObject, JsonProperty } from 'json2typescript';
import { Moment } from 'moment';

import { DateAdapter } from '../../client/helpers/serializer/adapters/date.adapter';
import { PBCActivityInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBCActivity')
export class PBCActivity implements PBCActivityInterface {
    @JsonProperty('nombre', StringAdapter)
    private _name: string = undefined;

    @JsonProperty('tipo', StringAdapter)
    private _type: string = undefined;

    @JsonProperty('descripcion', StringAdapter)
    private _description: string = undefined;

    @JsonProperty('fechaInicio', DateAdapter, true)
    private _startDate?: Moment = undefined;

    @JsonProperty('fechaFin', DateAdapter, true)
    private _endDate?: Moment = undefined;

    get name(): string {
        return this._name;
    }

    get type(): string {
        return this._type;
    }

    get description(): string {
        return this._description;
    }

    get startDate(): Moment {
        return this._startDate;
    }

    get endDate(): Moment {
        return this._endDate;
    }
}
